  export function setSellers(state, sellers) {
      state.sellers=sellers;
  }


// WEBPACK FOOTER //
// ./src/modules/reassign_seller/mutations.js